module.exports = new __parcel__URL__("mobile.9653a1cc.glb").toString();